
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'pricing-pages-ui',
  currentProjectVersion: 'static-1.38238',
  depVersions: {
  "pricing-pages-ui": "static-1.38238",
  "apollo-dlb": "static-3.41",
  "client-types": "static-1.372",
  "data-fetching-client": "static-1.8272",
  "demographics-service-types": "static-1.487",
  "eligibility-engine-service-types": "static-1.2019",
  "feature-store-service-types": "static-1.3330",
  "foundations-assets": "static-1.3565",
  "graphql": "static-1.58",
  "growth-monetization-service-types": "static-1.3337",
  "head-dlb": "static-1.3878",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6641",
  "hub-http": "static-1.4807",
  "hubspot-dlb": "static-2.1371",
  "HubStyleTokens": "static-2.10148",
  "I18n": "static-7.1378",
  "jasmine": "static-4.2994",
  "jasmine-runner": "static-1.5058",
  "laboratory-lib": "static-3.5908",
  "personalization-service-types": "static-1.1840",
  "pricing-pages-api": "static-1.7129",
  "pricing-pages-lib": "static-1.27948",
  "purchase-motions-components": "static-1.3767",
  "quartz": "static-1.5406",
  "react-dlb": "static-1.51",
  "react-rhumb": "static-1.15241",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.3368",
  "sanitize-text": "static-1.6832",
  "self-service-api": "static-1.8838",
  "signup-constants": "static-1.15908",
  "styled-components": "static-2.63",
  "trials-service-types": "static-1.2738",
  "ui-addon-upgrades": "static-9.15817",
  "upgrade-management-service-types": "static-1.3321",
  "usage-tracker-container": "static-1.6106",
  "webpack-env": "static-1.54",
  "account-and-billing-fintech-outages": "static-3.14900",
  "copilot-toolkit": "static-1.5702",
  "demographics-client": "static-1.4065",
  "enviro": "static-4.299",
  "foundations-components": "static-1.5819",
  "foundations-theming": "static-1.2964",
  "growth-payments-core": "static-1.20636",
  "hubspot-url-utils": "static-1.3028",
  "js-cookie": "static-1.18",
  "metrics-js": "static-1.8417",
  "onboarding-scopes": "static-1.5208",
  "payments-enrollment-embed-lib": "static-1.17136",
  "PortalIdParser": "static-2.277",
  "prefetcher": "static-1.4428",
  "pricing-pages-ui-components": "static-1.7267",
  "quartz-core": "static-1.4625",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4615",
  "react": "static-7.151",
  "react-redux": "static-7.16",
  "react-utils": "static-2.4198",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "SharedI18nStrings": "static-1.162",
  "signup-ui-url-generator": "static-2.6699",
  "touchless-buying-components": "static-1.3102",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10644",
  "ui-addon-i18n": "static-1.9577",
  "ui-addon-iframeable": "static-1.7543",
  "ui-addon-react-router-dom": "static-1.8264",
  "ui-addon-video-player": "static-1.7420",
  "UIComponents": "static-3.7096",
  "usage-tracker-core": "static-1.5966",
  "usage-tracker-multi": "static-1.4530",
  "apollo-stack-hubspot": "static-3.43",
  "hs-promise-rejection-tracking": "static-1.4156",
  "raven-hubspot": "static-1.4922",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "bend-plugin-trellis-migration": "static-1.2314",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1683",
  "quartz-webpack": "static-1.1630",
  "msw": "static-1.39",
  "ts-schema": "static-1.3010",
  "hs-story-utils": "static-1.8047",
  "HeadJS": "static-2.566",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1752",
  "testing-library": "static-1.120",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "superstore": "static-1.3423",
  "marketing-contacts-client": "static-1.6292",
  "nav-client-types": "static-1.1055",
  "purchase-motions-api": "static-1.3769",
  "usage-tracker": "static-1.6116",
  "quartz-core-utils": "static-1.2273",
  "StyleGuideUI": "static-3.454",
  "autolinker": "static-3.11",
  "sanitize": "static-1.3037",
  "csstype": "static-1.38",
  "atom": "static-1.3887",
  "cssUtils": "static-1.464",
  "HubStyle": "static-2.10457",
  "icons": "static-2.591",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.498",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14927",
  "bend-plugin-foundations-components": "static-1.2087",
  "floating-ui": "static-1.28",
  "foundations-theming-specialty": "static-1.681",
  "react-aria": "static-1.38",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.73",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.809",
  "bend-plugin-foundations-theming": "static-1.1447",
  "foundations-theming-base": "static-1.1949",
  "commerce-analytics-service-client": "static-1.2402",
  "frontend-preferences-client": "static-1.6527",
  "hs-lodash": "static-4.45",
  "ui-addon-opt": "static-4.7317",
  "crm_data": "static-4.86258",
  "customer-data-objects-ui-components": "static-1.11530",
  "growth-onboarding-confetti": "static-1.1761",
  "growth-onboarding-feedback-components": "static-1.5104",
  "growth-onboarding-reliability": "static-1.3811",
  "marketplace-ui-apps-core": "static-1.12105",
  "onboarding-tours": "static-1.13976",
  "stripe-embedded-components": "static-1.4988",
  "dispatcher": "static-1.111",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.639",
  "hub-http-shared-msw-handlers": "static-1.6889",
  "hubspotter-http": "static-1.3460",
  "hubspotter-http-shared-msw-handlers": "static-1.6887",
  "mobile-manifest-mixins": "static-1.337",
  "platform-navigation-bootstrap": "static-1.11062",
  "immer": "static-1.33",
  "checkout-sdk": "static-3.20721",
  "checkout-service-types": "static-1.2809",
  "company-details-components": "static-1.4560",
  "emoji-regex": "static-1.7",
  "foundations-components-test-utils": "static-1.3304",
  "payment-method-components": "static-1.5188",
  "upgrade-catalog-service-types": "static-1.2544",
  "ai-components-ui-library": "static-1.5013",
  "hs-promise-utils": "static-1.4178",
  "hubs-service-types": "static-1.109",
  "user-context": "static-1.3822",
  "magpie-lib": "static-1.4325",
  "navigation-messaging": "static-1.2889",
  "usage-tracker-anonymous": "static-1.4533",
  "usage-tracker-public": "static-1.5927",
  "sassPrefix": "static-1.130",
  "feedback-loader": "static-1.26294",
  "crm_schema": "static-3.86295",
  "crm_universal": "static-1.20387",
  "customer-data-email": "static-1.15560",
  "customer-data-objects": "static-1.6257",
  "customer-data-ui-utilities": "static-1.8379",
  "native-integrations-shared-strings": "static-1.6486",
  "property-translator": "static-1.4040",
  "avatar-components": "static-1.1067",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.6803",
  "ui-addon-avatars": "static-2.8081",
  "developer-experience-shared-components": "static-1.8740",
  "immutable-less": "static-1.3214",
  "marketplace-ui-client-types": "static-1.10975",
  "marketplace-ui-common": "static-1.13569",
  "ui-addon-integrations-directory-panel": "static-2.6643",
  "ui-extensibility-client-types": "static-1.2837",
  "ui-universal-auth": "static-1.7444",
  "getting-started-shared-tasks": "static-1.11643",
  "growth-data-modal": "static-1.3859",
  "navigation-components": "static-1.13562",
  "ui-shepherd-react": "static-3.8702",
  "ui-shepherd-tracker": "static-1.6083",
  "stripe-connect-js": "static-1.37",
  "platform-infra-nav-components": "static-1.6565",
  "hub-http-rxjs": "static-1.606",
  "normalizr": "static-3.9",
  "PatternValidationJS": "static-1.437",
  "ramda": "static-1.7",
  "rxjs": "static-5.10",
  "company-details-service-types": "static-1.2582",
  "final-form": "static-1.39",
  "billing-payments-client-types": "static-1.2721",
  "ContentUtils": "static-1.62640",
  "getting-started-shared-tasks-store": "static-1.10761",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3785",
  "simple-logging-lib": "static-1.1687",
  "FormUrlGenerator": "static-2.3377",
  "apollo-link-hub-http": "static-2.3441",
  "FileManagerCore": "static-1.33363",
  "FileManagerLib": "static-1.33504",
  "hubspot-apollo-client": "static-1.3481",
  "react-immutable-render-mixin": "static-1.9",
  "timezone-utils": "static-2.3903",
  "ui-gdpr-components": "static-1.8901",
  "react-dnd-compat": "static-1.3307",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2946",
  "nav-meta": "static-1.25199",
  "react-window": "static-1.13",
  "cms-field-types": "static-1.3441",
  "content-icons-ui": "static-1.1867",
  "underscore": "static-1.8",
  "audio-components": "static-1.4279",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.17863",
  "FileManagerImages": "static-1.31014",
  "urlinator": "static-1.3204",
  "video-components": "static-1.7226",
  "video-data-lib": "static-1.28874",
  "video-embed": "static-1.29715",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "content-assistance-lib": "static-1.6128",
  "media-bridge-lib": "static-1.16468",
  "immerable": "static-1.2811",
  "social-insights-client-types": "static-1.17359",
  "outpost": "static-1.3000",
  "react-transition-group": "static-1.7",
  "ui-coaching-tips": "static-1.22040"
},
  depPathPrefixes: {
  "pricing-pages-ui": "/pricing-pages-ui/static-1.38238",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "client-types": "/client-types/static-1.372",
  "data-fetching-client": "/data-fetching-client/static-1.8272",
  "demographics-service-types": "/demographics-service-types/static-1.487",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2019",
  "feature-store-service-types": "/feature-store-service-types/static-1.3330",
  "foundations-assets": "/foundations-assets/static-1.3565",
  "graphql": "/graphql/static-1.58",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3337",
  "head-dlb": "/head-dlb/static-1.3878",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6641",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-dlb": "/hubspot-dlb/static-2.1371",
  "HubStyleTokens": "/HubStyleTokens/static-2.10148",
  "I18n": "/I18n/static-7.1378",
  "jasmine": "/jasmine/static-4.2994",
  "jasmine-runner": "/jasmine-runner/static-1.5058",
  "laboratory-lib": "/laboratory-lib/static-3.5908",
  "personalization-service-types": "/personalization-service-types/static-1.1840",
  "pricing-pages-api": "/pricing-pages-api/static-1.7129",
  "pricing-pages-lib": "/pricing-pages-lib/static-1.27948",
  "purchase-motions-components": "/purchase-motions-components/static-1.3767",
  "quartz": "/quartz/static-1.5406",
  "react-dlb": "/react-dlb/static-1.51",
  "react-rhumb": "/react-rhumb/static-1.15241",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.3368",
  "sanitize-text": "/sanitize-text/static-1.6832",
  "self-service-api": "/self-service-api/static-1.8838",
  "signup-constants": "/signup-constants/static-1.15908",
  "styled-components": "/styled-components/static-2.63",
  "trials-service-types": "/trials-service-types/static-1.2738",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15817",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3321",
  "usage-tracker-container": "/usage-tracker-container/static-1.6106",
  "webpack-env": "/webpack-env/static-1.54",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14900",
  "copilot-toolkit": "/copilot-toolkit/static-1.5702",
  "demographics-client": "/demographics-client/static-1.4065",
  "enviro": "/enviro/static-4.299",
  "foundations-components": "/foundations-components/static-1.5819",
  "foundations-theming": "/foundations-theming/static-1.2964",
  "growth-payments-core": "/growth-payments-core/static-1.20636",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3028",
  "js-cookie": "/js-cookie/static-1.18",
  "metrics-js": "/metrics-js/static-1.8417",
  "onboarding-scopes": "/onboarding-scopes/static-1.5208",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17136",
  "PortalIdParser": "/PortalIdParser/static-2.277",
  "prefetcher": "/prefetcher/static-1.4428",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.7267",
  "quartz-core": "/quartz-core/static-1.4625",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4615",
  "react": "/react/static-7.151",
  "react-redux": "/react-redux/static-7.16",
  "react-utils": "/react-utils/static-2.4198",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6699",
  "touchless-buying-components": "/touchless-buying-components/static-1.3102",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10644",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9577",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7543",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8264",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7420",
  "UIComponents": "/UIComponents/static-3.7096",
  "usage-tracker-core": "/usage-tracker-core/static-1.5966",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4530",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4156",
  "raven-hubspot": "/raven-hubspot/static-1.4922",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2314",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1683",
  "quartz-webpack": "/quartz-webpack/static-1.1630",
  "msw": "/msw/static-1.39",
  "ts-schema": "/ts-schema/static-1.3010",
  "hs-story-utils": "/hs-story-utils/static-1.8047",
  "HeadJS": "/HeadJS/static-2.566",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1752",
  "testing-library": "/testing-library/static-1.120",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "superstore": "/superstore/static-1.3423",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6292",
  "nav-client-types": "/nav-client-types/static-1.1055",
  "purchase-motions-api": "/purchase-motions-api/static-1.3769",
  "usage-tracker": "/usage-tracker/static-1.6116",
  "quartz-core-utils": "/quartz-core-utils/static-1.2273",
  "StyleGuideUI": "/StyleGuideUI/static-3.454",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.3037",
  "csstype": "/csstype/static-1.38",
  "atom": "/atom/static-1.3887",
  "cssUtils": "/cssUtils/static-1.464",
  "HubStyle": "/HubStyle/static-2.10457",
  "icons": "/icons/static-2.591",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.498",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14927",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2087",
  "floating-ui": "/floating-ui/static-1.28",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.681",
  "react-aria": "/react-aria/static-1.38",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.73",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.809",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1447",
  "foundations-theming-base": "/foundations-theming-base/static-1.1949",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6527",
  "hs-lodash": "/hs-lodash/static-4.45",
  "ui-addon-opt": "/ui-addon-opt/static-4.7317",
  "crm_data": "/crm_data/static-4.86258",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11530",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1761",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5104",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3811",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12105",
  "onboarding-tours": "/onboarding-tours/static-1.13976",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4988",
  "dispatcher": "/dispatcher/static-1.111",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.639",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6889",
  "hubspotter-http": "/hubspotter-http/static-1.3460",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6887",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.337",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11062",
  "immer": "/immer/static-1.33",
  "checkout-sdk": "/checkout-sdk/static-3.20721",
  "checkout-service-types": "/checkout-service-types/static-1.2809",
  "company-details-components": "/company-details-components/static-1.4560",
  "emoji-regex": "/emoji-regex/static-1.7",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3304",
  "payment-method-components": "/payment-method-components/static-1.5188",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2544",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5013",
  "hs-promise-utils": "/hs-promise-utils/static-1.4178",
  "hubs-service-types": "/hubs-service-types/static-1.109",
  "user-context": "/user-context/static-1.3822",
  "magpie-lib": "/magpie-lib/static-1.4325",
  "navigation-messaging": "/navigation-messaging/static-1.2889",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4533",
  "usage-tracker-public": "/usage-tracker-public/static-1.5927",
  "sassPrefix": "/sassPrefix/static-1.130",
  "feedback-loader": "/feedback-loader/static-1.26294",
  "crm_schema": "/crm_schema/static-3.86295",
  "crm_universal": "/crm_universal/static-1.20387",
  "customer-data-email": "/customer-data-email/static-1.15560",
  "customer-data-objects": "/customer-data-objects/static-1.6257",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8379",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6486",
  "property-translator": "/property-translator/static-1.4040",
  "avatar-components": "/avatar-components/static-1.1067",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.6803",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8081",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8740",
  "immutable-less": "/immutable-less/static-1.3214",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10975",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13569",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6643",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2837",
  "ui-universal-auth": "/ui-universal-auth/static-1.7444",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11643",
  "growth-data-modal": "/growth-data-modal/static-1.3859",
  "navigation-components": "/navigation-components/static-1.13562",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8702",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6083",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6565",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.606",
  "normalizr": "/normalizr/static-3.9",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ramda": "/ramda/static-1.7",
  "rxjs": "/rxjs/static-5.10",
  "company-details-service-types": "/company-details-service-types/static-1.2582",
  "final-form": "/final-form/static-1.39",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2721",
  "ContentUtils": "/ContentUtils/static-1.62640",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10761",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3785",
  "simple-logging-lib": "/simple-logging-lib/static-1.1687",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3377",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3441",
  "FileManagerCore": "/FileManagerCore/static-1.33363",
  "FileManagerLib": "/FileManagerLib/static-1.33504",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3481",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "timezone-utils": "/timezone-utils/static-2.3903",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8901",
  "react-dnd-compat": "/react-dnd-compat/static-1.3307",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2946",
  "nav-meta": "/nav-meta/static-1.25199",
  "react-window": "/react-window/static-1.13",
  "cms-field-types": "/cms-field-types/static-1.3441",
  "content-icons-ui": "/content-icons-ui/static-1.1867",
  "underscore": "/underscore/static-1.8",
  "audio-components": "/audio-components/static-1.4279",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.17863",
  "FileManagerImages": "/FileManagerImages/static-1.31014",
  "urlinator": "/urlinator/static-1.3204",
  "video-components": "/video-components/static-1.7226",
  "video-data-lib": "/video-data-lib/static-1.28874",
  "video-embed": "/video-embed/static-1.29715",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "content-assistance-lib": "/content-assistance-lib/static-1.6128",
  "media-bridge-lib": "/media-bridge-lib/static-1.16468",
  "immerable": "/immerable/static-1.2811",
  "social-insights-client-types": "/social-insights-client-types/static-1.17359",
  "outpost": "/outpost/static-1.3000",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22040"
}
};
